import Component from '../../../scripts/utilities/component';

class StacklaWidget extends Component {
    componentDidMount() {
        const clickableTags = ['A', 'BUTTON'];
        const rootIsClickable = clickableTags.indexOf(this.root.nodeName) > -1;

        /*
            If the root is a clickable tag, load the stackla widget only when the root has
            been clicked. Otherwise, if the component was added to any other element, load
            the widget straight away.
        */
        if (rootIsClickable) {
            this.root.addEventListener('click', () => {
                this.loadWidget(document, 'stackla-widget-js');
            });
        } else {
            this.loadWidget(document, 'stackla-widget-js');
        }
    }

    loadWidget(d, id) {
        const widgetLoaded = window.Stackla;
        if (widgetLoaded) {
            return;
        }

        /* eslint-disable */
        var t,
            el = d.scripts[d.scripts.length - 1].previousElementSibling;
        if (el) el.dataset.initTimestamp = new Date().getTime();
        if (d.getElementById(id)) return;
        t = d.createElement('script');
        t.src = 'https://assetscdn.stackla.com/media/js/widget/fluid-embed.js';
        t.id = id;
        (d.getElementsByTagName('head')[0] || d.getElementsByTagName('body')[0]).appendChild(t);
        /* eslint-enable */
    }
}

export default StacklaWidget;



// WEBPACK FOOTER //
// ./components/eng-ms-load-stackla-widget/scripts/load-stackla-widget.js